<template>
    <div
        class="c-activities-list__item flex-container flex-align-stretch mb-7"
        v-bind:class="{ 'complete-item': isComplete }"
    >
        <div
            class="c-activities-list__item-checkbox flex-item-no-shrink"
            v-if="5 == activity.status_id"
        >
            <Icon
                class="text-muted"
                :custom="'icon icon-arrow-skip'"
                :size="14"
            />
        </div>
        <animated-checkbox
            v-else
            class="c-activities-list__item-checkbox flex-item-no-shrink"
            :checked="isComplete"
            @toggleCheckbox="handleCheck"
        ></animated-checkbox>
        <div class="c-activities-list__item-details" @click="handleOpen">
            <div class="c-activities-list__item-header">
                <div class="c-activities-list__item-header-left">
                    <Icon
                        v-if="activity.playbook_action"
                        custom="icon icon-flash_bold mr-1 text-warning"
                    />
                    <span class="c-activities-list__item-title">{{
                        activity.title
                    }}</span>
                </div>
                <div class="c-activities-list__item-header-right ml-5">
                    <span class="c-activities-list__item-date pr-3">
                        <formatted-date
                            :value="activity.scheduled_at"
                        ></formatted-date>
                    </span>
                    <Tooltip :content="priorityTooltipContent" placement="top">
                        <Badge :status="priorityBadgeStatus" />
                    </Tooltip>
                </div>
            </div>
            <div
                v-if="activity.comment"
                class="c-activities-list__item-description mt-1"
                v-html="activity.comment"
            ></div>
            <div
                v-if="
                    activity.playbook_action &&
                    activity.playbook_action.playbook.name
                "
                class="
                    c-activities-list__item-instructions
                    mt-3
                    text-secondary
                    truncate
                "
            >
                Triggered by the
                <span class="font-weight-bold">
                    {{ activity.playbook_action.playbook.name }}</span
                >
                Playbook
            </div>
            <div class="c-activities-list__item-footer mt-5">
                <div
                    v-if="activity.account"
                    class="c-activities-list__item-entity mr-3"
                >
                    <account-link
                        :id="activity.account.id"
                        :stop-propagation="true"
                    >
                        <letter-avatar
                            slot="inner"
                            :shape="'square'"
                            :name="activity.account.name"
                            :size="'tiny'"
                        ></letter-avatar>
                    </account-link>
                </div>
                <div
                    v-if="activity.account"
                    class="c-activities-list__item-entity mr-5"
                >
                    <account-link
                        :id="activity.account.id"
                        :stop-propagation="true"
                    >
                        <span
                            slot="inner"
                            class="c-activities-list__item-account"
                        >
                            {{ activity.account.name }}
                        </span>
                    </account-link>
                    <span v-if="activity.contact">
                        <Divider type="vertical" />
                        <!--                         <router-link :to="'/contacts/' + activity.contact.id">
 -->
                        <span class="c-activities-list__item-contact">
                            {{ activity.contact.full_name }}
                        </span>
                        <!--                         </router-link>
 -->
                    </span>
                </div>
                <div
                    class="c-activities-list__item-overview text-secondary mb-2"
                >
                    <span
                        v-if="
                            activity.relationship_counts.attachments_count > 0
                        "
                    >
                        <Icon custom="icon icon-attachment" />
                        {{ activity.relationship_counts.attachments_count }}
                        <Divider type="vertical" />
                    </span>
                    <span
                        v-if="activity.relationship_counts.activityusers_count"
                    >
                        <Icon custom="icon icon-read-email-at" />
                        {{ activity.relationship_counts.activityusers_count }}
                        <Divider type="vertical" />
                    </span>
                    <span
                        v-if="
                            activity.relationship_counts
                                .subactivitiescompleted_count > 0
                        "
                    >
                        <Icon custom="icon icon-list-bullets" />
                        {{
                            activity.relationship_counts
                                .subactivitiescompleted_count
                        }}
                        /
                        {{ activity.relationship_counts.subactivities_count }}
                        <Divider type="vertical" />
                    </span>
                    <span
                        v-if="activity.relationship_counts.comments_count > 0"
                    >
                        <Icon custom="icon icon-messages-bubble" />
                        {{ activity.relationship_counts.comments_count }}
                        <Divider type="vertical" />
                    </span>

                    <span v-if="isComplete">
                        <Tooltip :content="csmDateUpdated" placement="top">
                            <Icon
                                :custom="csmScoreIcon"
                                :class="csmScoreClass"
                            />
                        </Tooltip>

                        <Divider type="vertical" />
                    </span>
                    <!-- <span v-if="activity.owner.length > 0">
                        <Avatar :src="activity.owner.src" size="20" />
                        <Divider type="vertical" />
                    </span> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        activity: Object,
    },
    data() {
        return {};
    },
    components: {
        LetterAvatar: function () {
            return import("@/js/components/partials/letter-avatar");
        },
        AccountLink: function () {
            return import("@/js/components/partials/account-link");
        },
        AnimatedCheckbox: function () {
            return import("@/js/components/partials/animated-checkbox");
        },
        FormattedDate: function () {
            return import("@/js/components/partials/formatted-date");
        },
    },
    computed: {
        csmScoreClass() {
            switch (this.activity.csm_score) {
                case 1:
                    return "text-danger";
                case 2:
                    return "text-warning";
                case 3:
                    return "text-success";
                default:
                    return null;
            }
        },
        csmDateUpdated() {
            if (this.activity.csm_score_updated_at) {
                var locale =
                    this.$store.getters["mePreferences/LOCALE"] || "en-US";
                let date = this.$moment(this.activity.csm_score_updated_at)
                    .locale(locale)
                    .format(this.format || "LL");
                return "Score updated at " + date;
            } else {
                return "Not set";
            }
        },

        csmScoreIcon() {
            switch (this.activity.csm_score) {
                case 1:
                    return "icon icon-smiley-sad-1";
                case 2:
                    return "icon icon-smiley-indifferent";
                case 3:
                    return "icon icon-smiley-happy-1";
                default:
                    return "icon icon-smiley-indifferent";
            }
        },
        priorityTooltipContent() {
            switch (this.activity.priority_id) {
                case 1:
                    return "Low Priority";
                case 2:
                    return "Medium Priority";
                case 3:
                    return "High Priority";
                default:
                    return "Priority Not Set";
            }
        },
        priorityBadgeStatus() {
            switch (this.activity.priority_id) {
                case 1:
                    return "success";
                case 2:
                    return "warning";
                case 3:
                    return "error";
                default:
                    return "default";
            }
        },
        isComplete() {
            return this.activity.status_id === 2 ? true : false;
        },
    },
    watch: {},
    methods: {
        formatedCurrentDate() {
            let date = this.$moment().utc().toISOString();
            date = date.split("T")[0];
            return date;
        },
        myDateFormatted(activityDate) {
            return this.$moment(activityDate).calendar();
        },
        handleCheck() {
            if (this.activity.status_id === 2) {
                this.activity.status_id = 1;
                this.activity.completed_at = null;
                this.activity.completed_by_id = null;
                this.$emit("check", this.activity);
            } else {
                this.activity.status_id = 2;
                this.activity.completed_at = this.formatedCurrentDate();
                this.activity.completed_by_id = this.$store.getters["me/ID"];
                this.$emit("check", this.activity);
            }
        },
        handleOpen() {
            this.$root.$emit("open-modal", {
                type: "activity",
                props: {
                    id: this.activity.id,
                },
            });
        },
    },
};
</script>
